import { useSelector } from 'react-redux';

const deepClone = data => (data ? JSON.parse(JSON.stringify(data)) : null);

// Stored array order is the display order. Unknown keys are dropped and any default
// field missing from the stored list (older shops, newly added keys) goes at the end.
export const mergeDefaultFields = stored => {
  const known = (Array.isArray(stored) ? stored : []).filter(
    (x, i, arr) => DEFAULT_KEYS.includes(x?.field) && arr.findIndex(y => y?.field === x.field) === i
  );
  const missing = DEFAULT_FIELDS.filter(d => !known.some(x => x.field === d.field));
  return deepClone([...known, ...missing]);
};

export const useRegisField = () => {
  const { regisField } = useSelector(state => state?.auth);

  const defaultFields = mergeDefaultFields(regisField?.defaultField);

  const customFields = regisField?.customFields || [];

  return {
    _id: regisField?._id,
    defaultFields,
    customFields,
    genderSetting: regisField?.genderSetting,
    headers: regisField?.headers || []
  };
};

export const useActivePreview = (defaultFields, customFields) => {
  const all = defaultFields.concat(customFields);

  const active = all.reduce((acc, curr) => {
    acc[curr.field] = Boolean(curr.active);
    return acc;
  }, {});

  const required = all.reduce((acc, curr) => {
    acc[curr.field] = Boolean(curr.required);
    return acc;
  }, {});

  return { active, required };
};

export const useActiveAndRequiredField = () => {
  const { regisField } = useSelector(state => state?.auth);

  const defaultFields = mergeDefaultFields(regisField?.defaultField);

  const customFields = regisField?.customFields || [];
  const all = defaultFields.concat(customFields);

  const active = all.reduce((acc, curr) => {
    acc[curr.field] = Boolean(curr.active);
    return acc;
  }, {});

  const required = all.reduce((acc, curr) => {
    acc[curr.field] = Boolean(curr.required);
    return acc;
  }, {});

  return { active, required };
};

export const createDefaultField = (field, required, active) => ({ field, required, active });
export const createCustomField = (field, name, required, active, type = 'text', options = [], branches = []) => ({
  field,
  name,
  required,
  active,
  type,
  options,
  branches
});

export const DEFAULT_FIELDS = [
  createDefaultField('firstName', false, true),
  createDefaultField('lastName', false, true),
  createDefaultField('gender', false, true),
  createDefaultField('phone', true, true),
  createDefaultField('email', false, true),
  createDefaultField('birthdate', false, true),
  createDefaultField('address', false, false),
  createDefaultField('sales', false, true)
];

export const DEFAULT_KEYS = ['firstName', 'lastName', 'gender', 'phone', 'email', 'birthdate', 'address', 'sales'];
